import type { ApprovalRequest } from '@/lib/types';
import { PostedView } from './PostedView';
import { PostedServiceView } from './PostedServiceView';
import { DuplicateView } from './DuplicateView';
import { RejectedView } from './RejectedView';
import { SupplierAmbiguousView } from './SupplierAmbiguousView';
import { SupplierNotFoundView } from './SupplierNotFoundView';
import { MultipleGrnsView } from './MultipleGrnsView';
import { GrnUnapprovedView } from './GrnUnapprovedView';
import { GrnNotFoundView } from './GrnNotFoundView';
import { AmountMismatchView } from './AmountMismatchView';
import { GrnDetailSplitUnsupportedView } from './GrnDetailSplitUnsupportedView';
import { TaxMismatchReviewView } from './TaxMismatchReviewView';
import { DateReviewView } from './DateReviewView';
import { ExpenseRebateReviewView } from './ExpenseRebateReviewView';
import { MixedPiBookContextView } from './MixedPiBookContextView';
import { ServicePrepView } from './ServicePrepView';
import { PostFailedView } from './PostFailedView';
import { ParseErrorView } from './ParseErrorView';
import { UnknownView } from './UnknownView';
import type { SupplierHit } from '../SupplierSearchPicker';

export interface BucketViewProps {
  req: ApprovalRequest;
  onSupplierPicked?: (s: SupplierHit) => void;
}

export function BucketView({ req, onSupplierPicked }: BucketViewProps) {
  if (req.status === 'posted' && (!req.bucket || req.bucket === 'POSTED')) {
    return <PostedView req={{ ...req, bucket: 'POSTED' }} />;
  }

  switch (String(req.bucket ?? '')) {
    case 'POSTED':
      return <PostedView req={req} />;
    case 'POSTED_SERVICE':
      return <PostedServiceView req={req} />;
    case 'DUPLICATE':
      return <DuplicateView req={req} />;
    case 'REJECTED':
      return <RejectedView req={req} />;
    case 'SUPPLIER_AMBIGUOUS':
      return <SupplierAmbiguousView req={req} />;
    case 'SUPPLIER_NOT_FOUND':
      return <SupplierNotFoundView req={req} onSupplierPicked={onSupplierPicked} />;
    case 'MULTIPLE_GRNS':
      return <MultipleGrnsView req={req} />;
    case 'GRN_UNAPPROVED':
      return <GrnUnapprovedView req={req} />;
    case 'GRN_NOT_FOUND':
      return <GrnNotFoundView req={req} />;
    case 'AMOUNT_MISMATCH':
      return <AmountMismatchView req={req} />;
    case 'GRN_DETAIL_SPLIT_UNSUPPORTED':
      return <GrnDetailSplitUnsupportedView req={req} />;
    case 'TAX_MISMATCH_REVIEW':
      return <TaxMismatchReviewView req={req} />;
    case 'DATE_REVIEW':
      return <DateReviewView req={req} />;
    case 'EXP_REB_REVIEW':
      return <ExpenseRebateReviewView req={req} />;
    case 'MIXED_PI_BOOK_CONTEXT':
      return <MixedPiBookContextView req={req} />;
    case 'SERVICE_PREP':
      return <ServicePrepView req={req} />;
    case 'POST_FAILED':
      return <PostFailedView req={req} />;
    case 'PARSE_ERROR':
      return <ParseErrorView req={req} />;
    default:
      return <UnknownView req={req} />;
  }
}
